<template>
  <div class="goods">
    <v-head :title="title"></v-head>
    <div class="contentOffLine">
      <van-field
        v-model.trim="oldPassword"
        type="password"
        label="旧密码"
        placeholder="请您输入您的原密码"
        required
        style="margin-top: 15px"
      />
      <van-field
        v-model.trim="newPassword"
        type="password"
        label="新密码"
        placeholder="请您输入您的新密码"
        required
      />
      <van-field
        v-model.trim="newPasswordTwo"
        type="password"
        label="确认密码"
        placeholder="请您输入您的新密码"
        required
      />
      <div class="buton">
        <van-button type="primary" @click="savePD">保 存</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import { passwordSubmit } from "@/api/login";
import { Field, Button, Toast, CellGroup } from "vant";
import vHead from "../../components/Subhead.vue";
import { getSessionStore } from "@/utils/sessionStorage";
export default {
  data() {
    return {
      title: "修改密码",
      oldPassword: "",
      newPassword: "",
      newPasswordTwo: "",
    };
  },
  components: {
    vHead,
    [Field.name]: Field,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [CellGroup.name]: CellGroup,
  },
  methods: {
    savePD() {
      let token = getSessionStore("access_token");
      let oldPassword = this.oldPassword,
        newPassword = this.newPassword,
        newPasswordTwo = this.newPasswordTwo,
        isChecked = this.$regexp.password(newPassword),
        regexpPassword = this.$regexp.chinese(newPassword),
        params = {
          oldPassword,
          newPassword,
          access_token: token,
        };

      if (!oldPassword) {
        Toast.fail("请输入旧密码");
        return false;
      } else if (!newPassword) {
        Toast.fail("请输入新密码");
        return false;
      } else if (!isChecked || regexpPassword) {
        Toast.fail("密码必须为8-16为包含字母、数字、符号中至少2种且不能有空格");
        return false;
      } else if (newPasswordTwo !== newPassword) {
        Toast.fail("两次新密码不一致");
        return false;
      } else {
      }

      passwordSubmit(params)
        .then((res) => {
          if (res.success) {
            Toast.success("修改密码成功");
            this.$router.push({ name: "MemberCenter" });
          } else {
            Toast.fail("用户信息获取失败");
          }
        })
        .catch((res) => {
          Toast.fail("您输入的旧密码不正确");
        });
    },
  },
};
</script>

<style lang="less" scoped>

.contentOffLine {
  padding: 20px 18px;
  .van-cell {
    padding: 15px 0;
  }
  .van-cell--required::before {
    display: none;
  }
  /deep/.van-cell--required .van-field__label::after {
    position: absolute;
    color: #ee0a24;
    font-size: 0.37333rem;
    content: "\00A0*";
  }
}

.buton button {
  width: 80%;
  margin: 0 auto;
  margin-top: 10%;
  display: block;
}
/deep/.van-field__label {
  width: 2.4rem;
  color: #666;
  font-size: 14px;
}
/deep/.van-cell--required {
  padding-top: 15px;
  padding-bottom: 15px;
  width: 96%;
  margin: 0 auto;
}
</style>